import { NgModule } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PerfectScrollbarShimComponent } from './perfect-scrollbar-shim.component';

@NgModule({
  imports: [NgScrollbarModule],
  declarations: [PerfectScrollbarShimComponent],
  exports: [PerfectScrollbarShimComponent],
})
export class PerfectScrollbarShimModule {}
